import {Dispatch} from 'redux';
import {
  STATS_DATA_BY_EVENT_ID_GET_INVALIDATE,
  STATS_DATA_BY_EVENT_ID_GET_REQUEST,
  STATS_DATA_BY_EVENT_ID_GET_RESPONSE,
} from '../../actionTypes';
import {
  StatsDataByEventIdAction,
  StatsDataByEventIdGetInvalidateAction,
  StatsDataByEventIdGetRequestAction,
  StatsDataByEventIdGetResponseAction,
} from '../types';
import standardizeError from '../../../utils/standardizeError';
import {statsByEventId as APIStatsByEventId} from '../../../API/sportEvents';
import {beMatchStatsToStatsData} from '../../../API/utils';
import {StatData} from '../../../utils/types';

/**
 * Action creator for the get request of the stats data (by event id)
 * @param id
 */
const getStatsDataByEventIdGetRequest = (id: string): StatsDataByEventIdGetRequestAction => ({
  type: STATS_DATA_BY_EVENT_ID_GET_REQUEST,
  payload: id,
});

/**
 * Action creator for the get response of the stats data request (by event id)
 */
const getStatsDataByEventIdGetResponse = (
  statsData: StatData[],
): StatsDataByEventIdGetResponseAction => ({
  type: STATS_DATA_BY_EVENT_ID_GET_RESPONSE,
  payload: {statsData},
});

/**
 * Action creator for the get invalidation of the stats data request (by event id)
 * @param error
 */
const getStatsDataByEventIdGetInvalidate = (
  error: Error,
): StatsDataByEventIdGetInvalidateAction => ({
  type: STATS_DATA_BY_EVENT_ID_GET_INVALIDATE,
  error: standardizeError(error),
});

/**
 * // TODO: document
 */
const getStatsDataByEventId = (id: string) => (
  dispatch: Dispatch,
): Promise<StatsDataByEventIdAction> => {
  dispatch(getStatsDataByEventIdGetRequest(id));

  return APIStatsByEventId(id)
    .then(beMatchStatsToStatsData)
    .then((statsData: StatData[]) => dispatch(getStatsDataByEventIdGetResponse(statsData)))
    .catch((error: Error) => dispatch(getStatsDataByEventIdGetInvalidate(error)));
};

export default getStatsDataByEventId;
